import { captureException } from "@sentry/nextjs";

import { DEFAULT_ENDPOINT } from "@utils/web3/endpoints";
import type { ValidatorScore } from "types/validator-info";

export async function fetchValidatorsScores(): Promise<
  ValidatorScore[] | undefined
> {
  try {
    const response = await fetch(
      `${DEFAULT_ENDPOINT.scoringEndpoint}/scores/breakdowns/last`
    );

    if (!response.ok) {
      throw new Error(`${response.statusText} /// ${response.status}`);
    }

    return await response.json();
  } catch (err) {
    captureException(err);
    return undefined;
  }
}
